<!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
<script setup>
/* eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text */
import { computed } from 'vue';
import {
  COMPACT_BUTTON_CLASS as compactButtonClass,
  PAGE_SIZE,
} from '../utils/pendentesConstants';
import { number } from '../utils/pendentesFormatters';

const props = defineProps({
  pageMeta: { type: Object, required: true },
  isLoadingItems: { type: Boolean, default: false },
});

const emit = defineEmits(['goToPage']);

const visiblePageNumbers = computed(() => {
  const totalPages = Number(props.pageMeta.totalPages || 1);
  const currentPage = Number(props.pageMeta.page || 1);
  if (totalPages <= 5) {
    return Array.from({ length: totalPages }, (_, index) => index + 1);
  }
  const start = Math.max(1, Math.min(currentPage - 2, totalPages - 4));
  return Array.from({ length: 5 }, (_, index) => start + index);
});
</script>

<template>
  <div
    class="mt-4 flex flex-col gap-3 rounded-lais border border-lais-border bg-white px-4 py-3 text-[13px] text-lais-text-muted shadow-lais-card sm:flex-row sm:items-center sm:justify-between"
  >
    <span>
      Página {{ pageMeta.page }} de {{ pageMeta.totalPages }} ·
      {{ number(pageMeta.total) }} registros · {{ PAGE_SIZE }} por página
    </span>
    <div class="grid grid-cols-2 gap-2 sm:flex sm:items-center">
      <button
        type="button"
        :class="compactButtonClass"
        :disabled="!pageMeta.hasPrevious || isLoadingItems"
        @click="emit('goToPage', pageMeta.page - 1)"
      >
        <span class="i-lucide-chevron-left size-4" aria-hidden="true" />
        Anterior
      </button>
      <button
        v-for="pageNumber in visiblePageNumbers"
        :key="pageNumber"
        type="button"
        class="hidden size-10 place-items-center rounded-lais border text-[13px] font-semibold transition sm:grid"
        :class="
          pageMeta.page === pageNumber
            ? 'border-lais-primary bg-lais-primary text-white'
            : 'border-lais-border bg-white text-lais-text hover:border-lais-primary hover:text-lais-primary'
        "
        :disabled="isLoadingItems"
        @click="emit('goToPage', pageNumber)"
      >
        {{ pageNumber }}
      </button>
      <button
        type="button"
        :class="compactButtonClass"
        :disabled="!pageMeta.hasNext || isLoadingItems"
        @click="emit('goToPage', pageMeta.page + 1)"
      >
        Proxima
        <span class="i-lucide-chevron-right size-4" aria-hidden="true" />
      </button>
    </div>
  </div>
</template>
